import React, { useState, useEffect } from "react";
import CreateNewArc from "./CreateNewArcForm";
import ChallengesList from "./ChallengesList";
import { Arc, db } from "../services/db";
import feather from "feather-icons";

interface Habit {
  name: string;
  timeOfDay?: { hour: string; minute: string; sec?: string };
  completed: boolean; // New property added to track habit completion
}

export default function MyArcs() {
  const [arcs, setArcs] = useState<Arc[]>([]);
  const [showForm, setShowForm] = useState(false);
  const [creatingArc, setCreatingArc] = useState(false);
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    loadArcs();
    // window.location.reload();
    feather.replace();
  }, [updated]); // Load arcs on initial render

  const loadArcs = async () => {
    try {
      const arcsFromDB = await db.getAllArcs();
      setArcs(arcsFromDB);
    } catch (error) {
      console.error("Error loading arcs:", error);
    }
  };

  const handleCreateNewArc = () => {
    setShowForm(true);
    setCreatingArc(true);
  };

  // Function to check if all habits within an arc are completed
  const allHabitsCompleted = (arc: Arc) => {
    return arc.habits.every((habit) => habit.completed);
  };

  return (
    <div className="flex flex-col ">
      {!showForm && (
        <div className="text-left pt-4">
          <button className="btn btn-primary ml-2" onClick={handleCreateNewArc}>
            Create New Challenge
            <i data-feather="plus-circle"></i>
          </button>
          {arcs?.length > 0 && <ChallengesList arcs={arcs} updated={updated} />}
        </div>
      )}

      {showForm && (
        <div className="text-left">
          <button
            className="text-left  justify-center mt-4 ml-4 btn btn-primary"
            onClick={() => setShowForm(false)}
          >
            Go to My Challenges
            <i data-feather="arrow-left-circle"></i>
          </button>
        </div>
      )}
      {showForm && (
        <CreateNewArc
          setShowForm={setShowForm}
          setUpdated={setUpdated}
          arcs={arcs}
          setArcs={setArcs}
        />
      )}

      {/* Display completion message if all habits in each arc are completed */}
      {/* {arcs.every(allHabitsCompleted) && <p>All challenges completed!</p>} */}
    </div>
  );
}
